<template>
    <div class="box">
        <!-- 顶部轮播图-->
        <el-carousel class="lunbo" height="580px" style="min-width: 93.75rem">
            <el-carousel-item v-for="item in slideData" :key="item.id">
                <img :src="item.ossUrl" style="width: 100%;height:100%;" />
            </el-carousel-item>
        </el-carousel>
        <div :class="['selectTab', scrolled ? 'change-bg' : '']">
            <div class="Tab">
                <div class="tableft" style="margin-top: 8px; cursor: pointer"
                    @click="$router.push({ path: '/' }).catch(() => { })">
                    <img src="@/static/hebeichantoujijin.png" alt="" style="width: 100%; height: 100%" />
                </div>
                <div class="tabright" id="li">
                    <div class="tabrightli" v-show="!isSearch" :class="{ active: tabIndex == i }"
                        @click="changeTab(i, v, $event)" v-for="(v, i) of tabData" :key="i">
                        {{ v.title }}
                    </div>
                    <div class="tabrightli-search" style="cursor: auto">
                        <div :class="['search-box', isSearch ? 'is-search' : '']">
                            <img src="@/static/search.png" @click="isSearch = true" class="icon" style="width: 16px" />
                            <div class="input">
                                <input v-show="isSearch" type="text" v-model="keyword" placeholder="输入搜索关键词"
                                    @keyup.enter="Search" />
                            </div>
                            <div v-show="isSearch" class="close el-icon-close" @click="closeSearch"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="line"></div>
        </div>
        <div class="notice" v-if="showNews">
            <div class="Center">
                <div class="cenleft">
                    <img src="@/static/laba.png" style="width: 100%; height: 100%" />
                </div>
                <div class="centerTitle">公司要闻</div>
                <el-carousel style="width: calc(100% - 1.5rem - 120px);" height="74px" :interval="3000" trigger="click"
                    indicator-position="none" arrow="never">
                    <el-carousel-item v-for="(item, i) in ggListNew" :key="i">
                        <div class="centercount" @click="jumpDet(item2)" v-for="(item2,i2) in item" :key="item2.id">
                            <div class="text">{{ item2.title }}</div>
                            <div v-if="i2!=item.length-1" style="margin: 0 10px;margin-top: 2px;"><img src="../../static/icon_arrow_right.png" alt="" style="width:10px;height:20px;"></div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <!-- <el-carousel height="74px" interval="2000" trigger="click" indicator-position="none" arrow="never">
              <el-carousel-item v-for="item in gglist" :key="item.id">
                <div class="Center" @click="jumpDet(item)" style="cursor: pointer;">
                  <div class="cenleft">
                    <img src="@/static/laba.png" style="width: 100%; height: 100%"/>
                  </div>
                  <div class="centerTitle">公司要闻</div>
                  <div class="centercount">
                    {{item.title}}
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel> -->
        </div>
        <!-- <div style="height: 80px"></div> -->
    </div>
</template>

<script>
export default {
    name: "topWheel",
    props: {
        showNews: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            tabIndex: 0,
            gglist: [],
            ggListNew: [],
            tabData: [
                {
                    title: "网站首页",
                    path: "/",
                    params: {
                        type: "",
                        tabInd: 0,
                    },
                },
                {
                    title: "公司概况",
                    path: "/aboutUs",
                    params: {
                        type: "",
                        tabInd: 1,
                    },
                },
                {
                    title: "新闻中心",
                    path: "/newsCenter",
                    params: {
                        type: "xwzx",
                        tabInd: 2,
                    },
                },
                {
                    title: "业务板块",
                    path: "/business",
                    params: {
                        type: "",
                        tabInd: 3,
                    },
                },
                {
                    title: "投资项目",
                    path: "/product",
                    params: {
                        type: "",
                        tabInd: 4,
                    },
                },
                {
                    title: "政策法规",
                    path: "/newsCenter",
                    params: {
                        type: "zcfg",
                        tabInd: 5,
                    },
                },
                {
                    title: "公示公告",
                    path: "/newsCenter",
                    params: {
                        type: "gkgs",
                        tabInd: 6,
                    },
                },
                {
                    title: "党建工作",
                    path: "/newsCenter",
                    params: {
                        type: "djgz",
                        tabInd: 7,
                    },
                },
                {
                    title: "OA办公",
                    path: "/",
                    params: {
                        type: "",
                        tabInd: 8,
                    },
                },
                {
                    title: "联系我们",
                    path: "/contact",
                    params: {
                        type: "",
                        tabInd: 9,
                    },
                },
            ],
            scrolled: false,
            slideData: [], // 轮播图数据
            queryParams: {
                pageSize: 9,
                pageNum: 1,
                classify: "",
            },
            isSearch: false,
            keyword: "",
        };
    },
    created() {
        this.tabIndex = this.$route.query.tabInd;
        this.getList();
    },
    mounted() {
        this.$nextTick(() => {
            // window.addEventListener("scroll", this.handleScroll, true);
        });
        this.getSlideShowData();
    },
    destroyed() {
        // window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        jumpDet(v) {
            this.$router.push({
                path: "/articleDet",
                query: {
                    pageType: "xwzx",
                    pageName: "公司要闻",
                    ...v,
                },
            });
        },
        Search() {
            if (this.keyword === "") {
                this.$message.error("请输入关键字搜索！");
                return false;
            }
            this.$router
                .push({
                    path: "/search",
                    query: {
                        keyword: this.keyword,
                    },
                })
                .catch(() => { });
        },
        closeSearch() {
            this.isSearch = false;
            this.keyword = "";
        },
        // 获取公告新闻
        getList() {
            this.gglist = [];
            this.$api
                .getpressCenter({
                    classify: 1,
                    ...this.queryParams,
                })
                .then((res) => {
                    this.gglist = res.rows.length != 0 ? res.rows : [];
                    if (this.gglist.length > 0) {
                        // 使用map函数和Array.from来创建分组  
                        // 每个组包含最多3个元素  
                        this.ggListNew = Array.from({ length: Math.ceil(this.gglist.length / 3) }, (_, i) => {
                            // 计算每个组的起始索引  
                            const startIndex = i * 3;
                            // 使用slice来截取当前组的元素，最多3个  
                            return this.gglist.slice(startIndex, startIndex + 3);
                        });
                    }
                    console.log(this.ggListNew, '新增公告');
                });
        },
        getSlideShowData() {
            this.$api.slideShowListApi({}).then((res) => {
                this.slideData = res.data;
            });
        },
        changeTab(num, v, $event) {
            if (v.title == "OA办公") {
                window.open("//47.93.12.207");
                return false;
            }
            this.tabIndex = num;
            this.$emit("checkTab", this.tabIndex);
            this.$router.push(
                { path: v.path, query: v.params },
                () => { },
                () => { }
            );
        },
        handleScroll() {
            let scroll =
                document.body.scrollTop != 0
                    ? document.body.scrollTop
                    : document.documentElement.scrollTop;
            // console.log(scroll,'----------',document.documentElement.scrollTop)
            this.scrolled = scroll > 50; // 100是阈值，表示滚动100px后改变背景色
            // document.querySelector('li').style.color = '#000'
        },
    },
};
</script>
<style lang="less" scoped>
.change-bg {
    background-color: #fff;
    box-shadow: 0 0 1px 2px #eee;

    .Tab .tabright div {
        color: #000 !important;
    }

    img {
        filter: invert(100%);
    }
}

.active {
    font-size: 1.125rem
        /* 18/16 */
    ;
    font-weight: bold;
    color: #ffffff;
    line-height: 0rem
        /* 0/16 */
    ;
    text-align: center;
    font-style: normal;
    text-decoration-line: underline;
    text-transform: none;
}

.box {
    //max-width: 1920px;
    height: 580px
        /* 600/16 */
    ;
    margin: 0 auto;
    position: relative;
    min-width: 93.75rem
        /* 1500/16 */
    ;

    .lunbo {
        width: 100%;
        height: 580px
            /* 600/16 */
        ;
    }

    .tabrightli-search {
        margin-left: 2.8125rem
            /* 45/16 */
        ;
        display: flex;
        align-items: center;
    }

    .search-box {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        position: relative;

        .icon,
        .close {
            cursor: pointer;
            width: 16px;
            font-size: 20px;
        }

        .icon {
            margin-right: 0;
        }

        .close {
            position: absolute;
            right: 0;
        }

        .input {
            input {
                background-color: transparent;
                outline: none;
                border: none;
                width: 100%;
            }

            transition: width 0.3s ease;
            width: 0;

            &:after {
                background-color: currentColor;
                bottom: -5px;
                content: "";
                display: block;
                height: 1px;
                left: 0;
                opacity: 0.5;
                position: absolute;
                right: 0;
                bottom: -10px;
                visibility: hidden;
            }
        }

        &.is-search {
            .icon {
                margin-right: 1em;
            }

            .input {
                width: 500px;

                &:after {
                    visibility: visible;
                }
            }
        }
    }

    .selectTab {
        width: 100%;
        position: absolute;
        top: 0;
        z-index: 100;
        // padding: 0 6.5rem /* 104/16 */;
        min-width: 93.75rem
            /* 1500/16 */
        ;
        transition: 0.5s;
        padding: 0 6.25rem;
        border-bottom: 1px solid #fff;

        .line {
            width: 100%;
            border: 0.0625rem
                /* 1/16 */
                solid #ffffff;
            opacity: 0;
        }

        .Tab {
            //width: 92.75rem /* 1484/16 */;
            height: 5rem
                /* 80/16 */
            ;
            //margin: 0 auto;
            display: flex;
            align-items: center;
            font-size: 1.125rem
                /* 18/16 */
            ;
            color: #ffffff;
            position: relative;
            justify-content: space-between;

            .tableft {
                width: 14.3125rem
                    /* 229/16 */
                ;
                flex: 0 0 auto;
                margin-right: 4.75rem
                    /* 76/16 */
                ;
            }

            .tabright {
                display: flex;
                // width: calc(100% - 14.3125rem);
                justify-content: space-between;
            }

            .tabright .tabrightli {
                display: flex;
                align-items: center;
                margin-left: 2rem;
                width: 4.5rem
                    /* 72/16 */
                ;
                height: 1.5rem
                    /* 24/16 */
                ;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-size: 1.125rem
                    /* 18/16 */
                ;
                color: #ffffff;
                line-height: 0rem
                    /* 0/16 */
                ;
                font-style: normal;
                text-transform: none;
                cursor: pointer;
            }

            .tabright div:nth-child(1) {
                margin-left: 0rem
                    /* 0/16 */
                ;
            }
        }
    }

    .notice {
        width: 100%;
        height: 4.625rem
            /* 74/16 */
        ;
        background: #ffffff;
        box-shadow: 0rem
            /* 0/16 */
            0rem
            /* 0/16 */
            0.375rem
            /* 6/16 */
            0.0625rem
            /* 1/16 */
            rgba(0, 0, 0, 0.16);
        border-radius: 0rem
            /* 0/16 */
            0rem
            /* 0/16 */
            0rem
            /* 0/16 */
            0rem
            /* 0/16 */
        ;

        .Center {
            width: 92.5625rem
                /* 1481/16 */
            ;
            height: 100%;
            padding: 0 6.5rem;
            // background-color: pink;
            margin: 0 auto;
            display: flex;
            align-items: center;

            .cenleft {
                width: 1.5rem
                    /* 24/16 */
                ;
                height: 1.5rem
                    /* 24/16 */
                ;
                margin-right: 0.9375rem
                    /* 15/16 */
                ;
            }

            .centerTitle {
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: bold;
                font-size: 1.5rem
                    /* 24/16 */
                ;
                color: #1e439b;
                // line-height: 0px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-right: 3rem
                    /* 48/16 */
                ;
                width: 120px;
            }

            .centercount {
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 400;
                font-size: 22px;
                color: #333333;
                text-align: left;
                font-style: normal;
                text-transform: none;
                cursor: pointer;
                height: 100%;
                display: flex;
                // flex-direction: column;
                align-items: center;
                float: left;
                width: 30%;
                .text{
                    width: 100%;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }
        }
    }
}</style>
